/**
 * What a picture allowance draws in the bar's own row (`BarAllowance`, `theme.ts`), shared by the column's bar and
 * the sheet's: the note in the spacer after the identity chip, and the verb that stands in for the house's own when
 * the allowance is spent. Neither adds height under the bar.
 */
import type {BarAllowance} from './theme'
import styles from './AllowanceBar.module.scss'

export function BarNote({bar}: {bar: BarAllowance}) {
    const [first, second] = bar.note
    return (
        <span className={`${styles.note} ${bar.lit ? styles.lit : ''}`} role="status" aria-live="polite">
            <span>{first}</span>
            <span>{second}</span>
        </span>
    )
}

/** The allowance's verb in the bar's own verb class: a disabled label, or a document form posting to the house. */
export function BarVerb({verb, className}: {verb: NonNullable<BarAllowance['verb']>; className: string}) {
    const {label, disabled, post} = verb
    const button = (
        <button type={post ? 'submit' : 'button'} className={`${className} ${disabled ? styles.off : ''}`} disabled={disabled}>
            <span className={styles.label}>{label}</span>
        </button>
    )
    if (!post) return button
    return (
        <form method="post" action={post.action} onSubmit={post.onSubmit} className={styles.form}>
            {Object.entries(post.fields).map(([name, value]) => (
                <input key={name} type="hidden" name={name} value={value} />
            ))}
            {button}
        </form>
    )
}
